import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { SharedModule } from '../../shared/shared.module';
import { SendInvoiceContainerComponent } from './send-invoice-container';
import { SendInvoicePresenter } from './send-invoice-presenter';
import { SendInvoiceRoute } from './send-invoice.route';
import { SendInvoiceFilterComponent } from './send-invoice-filter';

@NgModule({
    declarations: [
        SendInvoiceContainerComponent,
        SendInvoicePresenter,
        SendInvoiceFilterComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        UIRouterModule,
        UIRouterModule.forChild({
            states: [SendInvoiceRoute]
        })
    ]
})
export class SendInvoiceModule {}
